import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9ed8dc46&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ed8dc46')) {
      api.createRecord('9ed8dc46', component.options)
    } else {
      api.reload('9ed8dc46', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9ed8dc46&", function () {
      api.rerender('9ed8dc46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/lostAndFound/index.vue"
export default component.exports